'use strict';

/**
 * This module is used to communicate through websocket.
 */
const webSocketHelper = {
  _socket: null,
  _host: 'wss://hr.crasman.fi/svt',
  _subscribe: [],
  _messageHandlers: [],

  /**
   * Send a message to the server through the web socket
   *
   * @param {string} text The message to send
   * @return {boolean} True on success, false on failure
   */
  send: function(text){
    if (typeof text === 'number') {
      text = text.toString();
    }
    if (typeof text !== 'string' || text === '') {
      return false;
    }

    // Check if WS connection is open
    if (this._socket === null || this._socket.readyState !== this._socket.OPEN) {
      return false;
    }

    try {
      const success = this._socket.send(text);
      return !!success;
    } catch(exception) {
      return false;
    }
  },

  /**
   * Start listening to messages from the server through the web socket
   *
   * @param {function} callback What to do when receiving data. First param of the function is the received data.
   * @return {boolean} True on success, false on failure
   */
  listen: function(callback) {
    if (typeof callback !== 'function') {
      return false;
    }

    // Connect to web socket if not already connected
    if (this._socket === null) {
      if (!this.connect(this._host)) {
        return false;
      }
    }

    this._socket.onmessage = this._handleWebSocketMessage.bind(this);

    return true;
  },

  /**
   * Handle message that came through web socket
   *
   * @param {object} response The data that came from the web socket
   */
  _handleWebSocketMessage: function(response) {
    if (this._messageHandlers.length === 0) {
      // No message handlers, nothing to do
      return;
    }

    try {
      const data = JSON.parse(response.data);

      this._messageHandlers.forEach(function(handler){
        handler.call(null, data);
      });
    } catch (e) {
      // Error. ¯\_(ツ)_/¯
    }
  },

  /**
   * Subscribe to certain messages, for example messages related to a certain auction
   *
   * @param {array|string} id The id to subscribe to. Can be multiple id's in an array.
   * @return {boolean} True on success, false on failure
   */
  subscribe: function(id) {
    if (typeof id === 'object') {
      this._subscribe = this._subscribe.concat(id);
    }
    else {
      this._subscribe.push(id);
    }

    if (this._socket !== null && this._socket.readyState === this._socket.OPEN) {
      // Socket is already open. Send new subscription details.
      return this.send(this._arrayToObject(this._subscribe));
    }
    else {
      // Socket is not yet open. It will send the subscription details when it's open.
      // Our job here is done.
      return true;
    }
  },

  /**
   * Translates subscribe array into a stringified object, which is accepted on the web socket server
   *
   * @param {array} subscribe The array to translate
   * @return {string} The stringified object in a format that is accepted by the web socket server
   */
  _arrayToObject: function(subscribe) {
    const obj = {};

    subscribe.forEach(function(id){
      obj[id] = 1;
    });

    return JSON.stringify({ subscribe: obj });
  },

  /**
   * Adds message handler that is executed when a messages comes in
   *
   * @param {function} handler The message handling function
   */
  addMessageHandler: function(handler) {
    this._messageHandlers.push(handler);
  },


  /**
   * Attempt to connect to the web socket server
   *
   * @param {string} host Hostname of the server
   * @return {boolean} True on success, false on failure
   */
  connect: function(host){
    const self = this;
    try{
      self._socket = new WebSocket(host);

      self._socket.onopen = function(){
        // When the connection is open, subscribe
        self.send(self._arrayToObject(self._subscribe));
      };

      self._socket.onclose = function(){
        // Reconnect
        setTimeout(self.connect, 5000);
      };

      return !!self._socket;
    } catch(exception){
      return false;
    }
  },

  init: function() {
    this.listen(this._handleWebSocketMessage.bind(this));
  }
};

module.exports = webSocketHelper;
